import { render } from "./TicketsList.vue?vue&type=template&id=7827892a&scoped=true&ts=true"
import script from "./TicketsList.vue?vue&type=script&lang=ts"
export * from "./TicketsList.vue?vue&type=script&lang=ts"

import "./TicketsList.vue?vue&type=style&index=0&id=7827892a&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7827892a"]])

export default __exports__